// Widget Scripts
import { themeController } from './js/ThemeControllers.js';
import swiperWidgetEventMode from './js/widgets/swiperWidget.js';
import calendar from './js/widgets/calendar.js';
import hotButtons from './js/widgets/hotButtons.js';
import cardWidget from './js/widgets/cardWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import videoWidget from './js/widgets/videoWidget.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';
import popUpWidget from './js/widgets/popUpWidget.js';
import subpageHero from './js/utils/subpageHero.js';

// Custom Theme Scripts
import './js/localjs.js';

$(document).ready(function () {
  themeController(themesConfig);
  subpageHero();

  // Initialize Homepage Widgets
  if (globalThis.location.pathname === '/') {
    if ($('body').hasClass('eventsMode')) {
      swiperWidgetEventMode('swiperWidgetEventMode', swiperWidgetEventModeOpts);
      calendar();
      hotButtons();
      cardWidget('cardWidgetEventMode', cardWidgetEventModeOpts);
      seoWidget('seoWidgetEventMode', seoWidgetEventModeOpts);
    } else {
      swiperWidgetEventMode('swiperWidget', swiperWidgetOpts);
      cardWidget('cardWidget', cardWidgetOpts);
      seoWidget('seoWidget', seoWidgetOpts);

      if (globalThis.location.href === SITEBASEURL + '?off') {
        sessionStorage.setItem('redirect', false);
        return;
      }

      if (sessionStorage.getItem('redirect') === 'false') {
        return;
      }

      globalThis.location.href = themesConfig[0].navItemUrl;
    }

    scrollerSponsors();

    $(globalThis).load(function () {
      videoWidget();
      popUpWidget();
    });

    $('.afterContent').remove();
  }
});
